import { createContext, useEffect, useState } from "react";
import { AuthService } from "../../api/AuthService";

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
    const [isReadNot, setIsReadNot] = useState(false);
    const [loading, setLoading] = useState(false);
    const [currentUser, setCurrentUser] = useState(() => {
        try {
            const storedUser = localStorage.getItem('dentaluser');
            return storedUser ? JSON.parse(storedUser) : null;
        } catch (e) {
            return null;
        }
    });

    const updateUser = (data) => setCurrentUser(data);
    const updateIsReadNot = (data) => setIsReadNot(data);

    useEffect(() => {
        const fetchUser = async () => {
            const token = localStorage.getItem('token');
            if (!token) return;

            setLoading(true);
            try {
                const response = await AuthService.getUserFromToken();

                const user = response?.data?.data || response?.data?.user;
                if (user) {
                    setCurrentUser(user);
                } else {
                    console.warn("No valid user returned.");
                }
            } catch (error) {
                console.error("Auth fetch failed:", error?.response || error);
                if (error?.response?.status === 401) {
                    setCurrentUser(null);
                    localStorage.removeItem('token');
                    localStorage.removeItem('dentaluser');
                }
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, []);

    useEffect(() => {
        if (currentUser) {
            localStorage.setItem('dentaluser', JSON.stringify(currentUser));
        } else {
            // ⚠️ Don't remove unless it's a confirmed logout or 401
            // This prevents accidental deletion during load
        }
    }, [currentUser]);

    return (
        <AuthContext.Provider value={{ currentUser, updateUser, isReadNot, updateIsReadNot, loading }}>
            {children}
        </AuthContext.Provider>
    );
};
